module.exports = __webpack_public_path__ + "static/media/Twitter.92dc0458.svg";